import script from "./ReLinkAccountsShoutPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReLinkAccountsShoutPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ReLinkAccountsShoutPanel.vue?vue&type=style&index=0&id=c3bd0a0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3bd0a0c"]])

export default __exports__